// © 2021 Amazon Web Services, Inc. or its affiliates. All Rights Reserved.
/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
// import Alert from "@awsui/components-react/alert";
import "../../index.css";
import params from "../../parameters.json";
import { Auth } from "aws-amplify";
import TopNavigation from "@awsui/components-react/top-navigation";
import { useHistory } from "react-router-dom";

function Header(props) {
  const history = useHistory();

  async function signOut() {
    try {
      await Auth.signOut();
    } catch (error) {
      console.log("error signing out");
    }
  }

  return (
    <div>
      <TopNavigation
        identity={{
          href: "/",
          title: "Kuehne+Nagel TEAM",
        }}
        utilities={[
          {
            type: "menu-dropdown",
            text: `${props.user}`,
            description: `${props.user}`,
            iconName: "user-profile",
            onItemClick: ({ detail }) => {
              if (detail.id === "signout") {
                signOut().then(() => history.push("/"));
              }
            },
            items: [
              { id: "signout", text: "Sign out" },
              {
                id: "support-group",
                text: "Support",
                items: [
                  {
                    id: "user-journey",
                    text: "User journey",
                    href: "https://wiki.int.kn/spaces/CCCKB/pages/1964690572/User+Journey+Guide+Temporary+Elevated+Access+Management",
                    external: true,
                    externalIconAriaLabel: " (opens in new tab)",
                  },
                  {
                    id: "bug",
                    text: "Report Bug",
                    href: "https://tic.int.kn/spaces/cloud-competence-centre/forms/generic-request1",
                    external: true,
                    externalIconAriaLabel: " (opens in new tab)",
                  },
                ],
              },
            ],
          },
        ]}
        onFollow={() => {
          history.push("/");
          props.setActiveHref("/");
          props.addNotification([]);
        }}
      />
    </div>
  );
}

export default Header;
